import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const disclosureTypes = createAsyncThunk(
  "disclosureTypes",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await doPost(urls?.disclosureTypes, arg);
      
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const disclosureTypesSlice = createSlice({
  name: "disclosureTypes",
  initialState: {
    isLoading: false,
    success: false,
    error: null,
    data: false,
  },
  reducers: {
    disclosureTypesReset: () => {
      return {
        isLoading: false,
        success: false,
        error: null,
        data: false,
      };
    },
  },
  extraReducers: {
    [disclosureTypes.fulfilled]: (state, {payload}) => {
      state.isLoading = false;
      state.data = payload;
      state.success = true;
      state.error = null;
    },
    [disclosureTypes.pending]: (state) => {
      state.isLoading = true;
      state.data = false;
      state.success = false;
    },
    [disclosureTypes.rejected]: (state, {payload}) => {
      state.isLoading = false;
      state.error = payload;
      state.data = false;
    },
  },
});

export const { disclosureTypesReset } = disclosureTypesSlice.actions;
